import React from "react";
import classNames from "classnames";

import {
  menuIcon,
  menuIconLine,
  open as openCls,
} from "./MenuIcon.module.scss";

interface MenuIconProps extends React.HTMLAttributes<HTMLButtonElement> {
  open?: boolean;
}

const MenuIcon: React.FC<MenuIconProps> = ({ open, className, ...props }) => {
  return (
    <button
      aria-label="Menu Button"
      className={classNames(menuIcon, { [openCls]: open }, className)}
      {...props}
    >
      <span className={menuIconLine} />
      <span className={menuIconLine} />
      <span className={menuIconLine} />
      <span className={menuIconLine} />
    </button>
  );
};

export { MenuIcon };
